import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import { StateType } from '#app/Store';
import DepositEntryPoints from '#app/entrypoints/deposit';
import { Option } from '#app/typings/utils';

type HookReturn = {
  deposit?: string;
};

const useDeposit = (): HookReturn => {
  const { deposit } = useParams<{ deposit?: string }>();
  const authenticationReducer = useSelector((state: StateType) => state.AuthenticationReducer);
  const { data: deposits } = useSWR<Option[]>(
    authenticationReducer.shopSelected
      ? generateApiPath(DepositEntryPoints.getSelect, {}, { limited: true, shopId: authenticationReducer.shopSelected })
      : null,
    getCollection,
    {
      revalidateOnFocus: false,
    },
  );

  return { deposit: deposit ?? deposits?.[0].value.toString() };
};

export default useDeposit;
